import BottomNav from "../../components/BottomNav/BottomNav";
import Header from "../../components/Header/Header";
import Sponsorships from "../../components/SponsorshipSection/SponsorshipSection";
import "./promotionDetail.css";
import clockImage from "../../images/iconclock.svg";
import { ChevronLeft } from "lucide-react";
import promoBanner from "../../images/event.png";
import { useNavigate, useLocation } from "react-router-dom";
import InnerHeader from "../../components/InnerHeader";
export default function PromotionDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  // Get promotion object from state
  const promotion = location.state?.promotion;
  if (!promotion) {
    navigate("/promotions");
    return null;
  }

  return (
    <div className="promo-page">
      <Header />
      {/* HEADER */}
      {/* <div className="promo-header-det">
        <ChevronLeft className="back-icon" />
        <span>Play & Get Free ₹1,000 Bonus</span>
      </div> */}
      <InnerHeader title={promotion.name} />
      {/* HERO BANNER */}
      <div className="promo-hero">
        <img
          src={
            promotion.thumbnail
              ? `${process.env.REACT_APP_API_URL}/storage/${promotion.thumbnail}`
              : "/images/event.png"
          }
          alt={promotion.name}
        />
      </div>

      {/* CATEGORY TABS */}
      <div className="promo-tabs-det">
        {[
          "All",
          "Cricket",
          "Casino",
          "Sports",
          "Fishing",
          "Lottery",
          "Table",
          "Cricket",
          "Casino",
          "Sports",
          "Fishing",
          "Lottery",
          "Table",
        ].map((t, i) => (
          <span key={i} className={t === "Cricket" ? "active" : ""}>
            {t}
          </span>
        ))}
      </div>
      <div className="clock-time">
        <img src={clockImage} alt="" />
        <span>
          {" "}
          {promotion.start_date && promotion.end_date
            ? `${new Date(promotion.start_date)?.toLocaleString()} ~ ${new Date(promotion.end_date)?.toLocaleString()}`
            : "2025/12/14 00:00:00 ~ 2026/01/31 23:59:59"}
        </span>
      </div>
      {/* CONTENT */}
      <div className="promo-body">
        <p>
          Gear up for a blazing cricket season with our Welcome Offer! Hit the
          field like a champion by making your minimum first deposit and placing
          a bet on any selected matches to unlock a blazing free bonus of up to
          ₹1,000.
        </p>

        <p>
          This promotion is available to all members who have not participated
          in any welcome offers on Baji.
        </p>

        <h3>What should you do?</h3>
        <ul>
          <li>Select this offer on the deposit page</li>
          <li>Make a minimum first deposit via any payment method</li>
          <li>Place your bets on eligible sports markets</li>
          <li>Bonus credited after requirements are met</li>
        </ul>

        <h3>Effective Turnover</h3>

        {/* TABLE */}
        <table className="border-table">
          <thead>
            <tr>
              <th>Header 1</th>
              <th>Header 2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Row 1 Col 1</td>
              <td>Row 1 Col 2</td>
            </tr>
            <tr>
              <td>Row 2 Col 1</td>
              <td>Row 2 Col 2</td>
            </tr>
            <tr>
              <td>Row 1 Col 1</td>
              <td>Row 1 Col 2</td>
            </tr>
            <tr>
              <td>Row 2 Col 1</td>
              <td>Row 2 Col 2</td>
            </tr>
          </tbody>
        </table>

        <h3>Bonus Wagering Requirements</h3>
        <ul>
          <li>Bonus credited within 12:30 (GMT+6)</li>
          <li>Bonus is subject to 7x wagering</li>
          <li>Only eligible sports markets qualify</li>
          <li>Void or cancelled bets do not count</li>
        </ul>

        <h3>Restrictions</h3>
        <ul>
          <li>Each member can participate once</li>
          <li>Only the first qualifying deposit applies</li>
          <li>Cash-out bets do not qualify</li>
          <li>Promotion cannot be combined</li>
        </ul>

        <h3>Other Terms</h3>
        <p>
          Baji reserves the right to withdraw bonuses or winnings if abuse,
          fraud, or irregular betting activity is detected.
        </p>
      </div>

      {/* STICKY CTA */}
      <div className="promo-cta">
        <button onClick={() => navigate("/deposit")}>Deposit Now</button>
      </div>
      <Sponsorships />
      <BottomNav />
    </div>
  );
}
